class PaymentContractBill {
	id = null;
	bill_number = null;
	date = new Date().toISOString().slice(0, 10);
	total = null;
	payment_contract_id = null;
	uploaded_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default PaymentContractBill;
